import React from "react";
import "../App.css"; // Importera CSS-filen

const InfoModal = ({ children, onCancel, onConfirm, btn1, btn2 }) => {
  return (
    <div className="infoModalOverlay">
      <div className="infoModal">
        {children}
        <div
          style={{
            marginTop: "1.5em",
            display: "flex",
            justifyContent: "center",
            gap: "1em",
          }}
        >
          {btn1 ? (
            <button className="infoModalBtn" onClick={onCancel}>
              {btn1 ? btn1 : "Stanna kvar"}
            </button>
          ) : null}
          {btn2 ? (
            <button className={!btn1? "infoModalBtn": "infoModalBtnClose"} onClick={onConfirm}>
              {btn2 ? btn2 : "Stäng ändå"}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
